<template>
  <div v-if="container">
    <treeselect
      @input="$emit('input', $event)"
      :options="options"
      :normalizer="normalizer"
      value-format="object"
      :disable-branch-nodes="true"
      :placeholder="placeholder || localization('app-select-layer','Select Layer')"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["placeholder"],
  computed: {
    ...mapState(["container"]),
    options() {
      return this.container.groups.map((group) => {
        group.projects.forEach((project, index) => {
          project.children = [];

          if (project.reports) {
            if (project.reports.dtm && project.reports.dtm.url)
              project.children.push(project.reports.dtm);
            if (project.reports.dsm && project.reports.dsm.url)
              project.children.push(project.reports.dsm);
          }
          if (!project.children.length) delete group.projects[index];
        });
        group.children = group.projects;
        return group;
      });
    },
  },
  methods: {
    normalizer(node) {
      return {
        id: node.uid,
        label: node.name,
        children: node.children,
      };
    },
  },
};
</script>

<style>
</style>